import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=90aef79a&scoped=true&"
import script from "./Resellers.vue?vue&type=script&lang=js&"
export * from "./Resellers.vue?vue&type=script&lang=js&"
import style0 from "./Resellers.vue?vue&type=style&index=0&id=90aef79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90aef79a",
  null
  
)

export default component.exports